import { apiBase } from './generated/apibase.json.js';
export const apibaseJson = apiBase;